@let items = (props.optionsService | async) ?? [];
@let optionItems = getOptionItems($any(items));

<dropdown-v2
  #optionDropdown
  [placeholder]="props.placeholder || ''"
  [items]="$any(items)"
  [wideItemsContainer]="true"
  (itemSelect)="selectOption($event)"
  [customListTemplate]="customListTemplate"
  [selectedItem]="selectedItem"
></dropdown-v2>

<ng-template
  #customListTemplate
  let-items="items"
  let-hoveredItem="hoveredItem"
  let-setHoveredItem="setHoveredItem"
>
  <dropdown-item-v2
    (click)="selectCreateNew()"
    [hovered]="hoveredItem?.value === ''"
    (mouseenter)="setHoveredItem({ label: 'Create new option', value: '' })"
    (mouseleave)="setHoveredItem(null)"
    class="create-new-item v2-p-4"
    data-id="create-new-option"
  >
    <typography-v2>Create new option</typography-v2>
  </dropdown-item-v2>

  @if (optionItems.length) {
    <div class="divider m-0"></div>
  }

  @for (item of optionItems; track item.value; let last = $last) {
    <dropdown-item-v2
      [hovered]="hoveredItem === item"
      (mouseenter)="setHoveredItem(item)"
      (mouseleave)="setHoveredItem(null)"
      (click)="toggleOption(item, $event)"
      class="option-item d-flex flex-column v2-p-4 cursor-pointer"
      [attr.data-id]="'option-' + item.value"
    >
      <div class="d-flex align-items-start w-100">
        <label class="checkbox-label">
          <input
            [checked]="isOptionChecked(item)"
            class="checkbox-input d-none"
            type="checkbox"
            tabindex="-1"
          />
          <div class="checkbox"></div>
        </label>

        <div class="option-content option-grid flex-grow-1">
          <typography-v2 class="option-title">Option {{ item.extras?.node?.id }}</typography-v2>

          <typography-v2 look="small" class="text-black-50 price">
            {{ item.extras?.node?.bookedCostPerAdult | rdrCurrency }}/adult
          </typography-v2>

          <option-itinerary-v2-unique-airline-images
            [option]="item.extras?.node"
            [isDropdown]="true"
            class="option-airlines"
          />

          @for (
            group of item.extras?.node?.flightItineraries;
            track trackFlightItinerary($index, group)
          ) {
            <div class="flight-route">
              <typography-v2 look="small" class="text-black-50">
                {{ getFlightItineraryRoute(group) }}
              </typography-v2>

              @if (getFlightItineraryStopsLabel(group); as stopsLabel) {
                <typography-v2 look="small" class="text-black-50 d-block">
                  {{ stopsLabel }}
                </typography-v2>
              }
            </div>

            <typography-v2 look="small" class="text-black-50 flight-time nowrap">
              {{
                getFlightItineraryDepartureAt(group)
                  | rdrDate: { format: 'short', withoutTimezones: true }
              }}
            </typography-v2>

            <div class="flight-spacer"></div>
          }
        </div>
      </div>
    </dropdown-item-v2>

    @if (!last) {
      <div class="divider"></div>
    }
  }
</ng-template>
